<template>
	<div>
		<div class="bigBox">
			<div class="leftCont">
				<div class="banners">
					<div class="mendio2">
						<div class="name6">为实体门店赋能升级</div>
						<div class="Intro6">开源：美团、抖音、微信、线下全联通</div>
						<div class="Intro6">节流：自助让客户轻松自由，让老板更省时省力</div> 
						<el-button type="text" class="Ufree" @click="goCont"><span 
							style="color: #fff !important;margin-left: unset !important;">预约咨询</span></el-button>
						<!--
						<el-button type="text" class="Ufree" @click="dvSaas = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(外卖)</span></el-button>
						<el-button type="text" class="Ufree" @click="dvQuan = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(MOMI互推)</span></el-button>
						<el-button type="text" class="Ufree" @click="dvStore = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(商城)</span></el-button>-->
						<div class="Comuni">咨询电话：159 8989 7729</div>
					</div>
				</div>
				<div class="pBox"> 
					<div class="pcont">
						<div class="pLeft">
							<div class="pLTitle">MOMI智慧自助空间系统，可靠的选择</div>
							<div class="pLcont">
								<li>基于物联网，为自助无人空间打造</li>
								<li>提供了管理、运营、用户等不同端功能</li>
								<li>打通了美团、抖音、微信及线下</li>
								<li>易扩展、可支撑电信级的技术架构</li>
							</div>
						</div>
						<div class="emtyImg">
							<img mode="widthFix" src="../assets/images/img6.png" class="pImg" />
						</div> 
					</div>
				</div>
				<div class="pBox2"> 
					<div class="pcont">
						<div class="pLeft">
							<div class="pLTitle">提供灵活的方案选择</div>
							<div class="pLcont">
								<li>根据不同需求，可选配不同行业版本</li>
								<li>随着品牌发展，可升级连锁</li>
								<li>针对个性化需求，亦可进行二次开发</li>
							</div>
						</div>
						<div class="emtyImg">
							<img mode="widthFix" src="../assets/images/img4.jpg" class="pImg" />
						</div>
					</div>
				</div>
				<div class="pBox"> 
					<div class="pcont">
						<div class="pLeft">
							<div class="pLTitle">优质的后续服务</div>
							<div class="pLcont">
								<li>每年2次免费的系统升级和检测服务</li>
								<li>可靠的系统维护人员</li>
								<li>比市场价低的二次开发服务</li>
							</div>
						</div>
						<div class="emtyImg">
							<img mode="widthFix" src="../assets/images/img5.jpg" class="pImg" />
						</div>
					</div>
				</div> 
				<div class="others">
					<img class="othersPic" src="../assets/images/def/hand.jpg" /> 
				</div>
				<msg-foot></msg-foot>
			</div>
			<right-cont :dialogVisible="dvSaas"></right-cont>
			<!-- <right-cont :dialogVisible="dvQuan"></right-cont>
			<right-cont :dialogVisible="dvStore"></right-cont> -->
		</div>
		<el-dialog title="" :visible.sync="dvSaas" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/saas_try.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
		<el-dialog title="" :visible.sync="dvQuan" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/qr_tool.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
		<el-dialog title="" :visible.sync="dvStore" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/store_try.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import msgFoot from '../components/msgFoot.vue'
	import rightCont from '../components/rightCont.vue'
	import axios from 'axios'
	export default {
		components: {
			msgFoot,
			rightCont
		},
		data() {
			return {
				textCss1: 'guideActive',
				textCss2: 'guideText',
				textCss3: 'guideText',
				textCss4: 'guideText',
				dialogVisible: false,
				dvSaas: false,
				dvQuan: false,
				dvStore: false, 
				activeIndex: '1'
			}
		},
		methods: {
			goCont()
			{  
				console.log('xxxxzz', this.$children[2]) 
				rightCont.openMe(this.$children[2]);
			},
			changeCont(e) {
				this.textCss1 = 'guideText'
				this.textCss2 = 'guideText'
				this.textCss3 = 'guideText'
				this.textCss4 = 'guideText'
				if (e == 1) {
					this.textCss1 = 'guideActive'
				} else if (e == 2) {
					this.textCss2 = 'guideActive'
				} else if (e == 3) {
					this.textCss3 = 'guideActive'
				} else if (e == 4) {
					this.textCss4 = 'guideActive'
				}
			},
			handleClose(done) {
				done();
			}
		},
		mounted() {
			window.scroll(0, 0);

		}
	}
</script>

<style>


</style>
